// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchBeginLoadCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import constants from "@store/constants";
import { CustomLoadCurrentCartParameter } from "@store/Extensions/Store/Types/LoadCurrentCart";

replaceInChain(chain, DispatchBeginLoadCart, async props => {
    const state = props.getState();
    /* Greif Custom Code - Start */
    const pageType = getCurrentPage(state).type;
    const isNotReviewAndSubmitPage = pageType !== constants.pageType.checkoutReviewAndSubmit;
    /* Greif Custom Code - End */

    if (isNotReviewAndSubmitPage /* Greif */ && getCurrentCartState(state).isLoading) {
        return false;
    }

    props.dispatch({
        type: "Data/Carts/BeginLoadCart",
        id: API_URL_CURRENT_FRAGMENT,
    });

    if (props.parameter.shouldLoadFullCart !== false) {
        await waitFor(() => getCurrentPage(props.getState()) !== nullPage);
    }
});

replaceInChain(chain, PopulateApiParameter, props => {
    PopulateApiParameter(props);

    const pageType = getCurrentPage(props.getState()).type;
    const expandWithoutTax = props.apiParameter.expand?.filter(x => x !== "tax");

    if (pageType !== constants.pageType.checkoutReviewAndSubmit) {
        props.apiParameter.expand = expandWithoutTax;
    } else {
        props.apiParameter.additionalQueryStringParameters = {
            ...props.apiParameter.additionalQueryStringParameters,
            timestamp: Date.now(),
        };
    }

    if ((props.parameter as CustomLoadCurrentCartParameter).shouldTriggerSoftSubmit) {
        props.apiParameter.shouldTriggerSoftSubmit = true;
    }
});
